import { __ } from '@wordpress/i18n';

const GROUPS = [
	{
		label: __( 'Basic information', 'anacrm' ),
		open: true,
		fields: [
			'post_title',
			'_ac_description',
			'_ac_keyword',
			'_ac_where',
			'_ac_space',
			'_ac_date_start',
			'_ac_date_end',
			'_ac_image',
			'_ac_signup',
		],
	},
	{
		label: __( 'Contact', 'anacrm' ),
		fields: [ '_ac_person_ref' ],
	},
	{
		label: __( 'Relations', 'anacrm' ),
		fields: [ '_ac_project', '_ac_org_ref', '_ac_person_registered' ],
	},
	{
		label: __( 'Registration fields', 'anacrm' ),
		fields: [ '_ac_registration_fields' ],
	},
];

function findFieldWrapper( form, name ) {
	const dashedName = name.replace( /_/g, '-' );
	return form.querySelector( `.pods-form-ui-row-name-${ dashedName }` );
}

function buildAccordion( form ) {
	for ( const group of GROUPS ) {
		const fieldWrappers = group.fields
			.map( ( f ) => findFieldWrapper( form, f ) )
			.filter( Boolean );
		if ( ! fieldWrappers.length ) {
			continue;
		}

		const parent = fieldWrappers[ 0 ].parentElement;

		const details = document.createElement( 'details' );
		if ( group.open ) {
			details.open = true;
		}
		details.className = 'mb-4 border-2 border-green';

		const summary = document.createElement( 'summary' );
		summary.className =
			'px-4 py-3 cursor-pointer select-none bg-green/30 hover:bg-green/60 marker:float-left';
		const summaryTit = document.createElement( 'h2' );
		summaryTit.className = 'text-base font-semibold inline-block';
		summaryTit.textContent = group.label;
		summary.appendChild( summaryTit );
		const summaryDesc = document.createElement( 'p' );
		summaryDesc.textContent = group.description ?? '';
		summary.appendChild( summaryDesc );
		details.appendChild( summary );

		const body = document.createElement( 'div' );
		body.className = 'px-4 py-2 bg-green/10';
		details.appendChild( body );

		parent.insertBefore( details, fieldWrappers[ 0 ] );
		fieldWrappers.forEach( ( w ) => body.appendChild( w ) );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const wrapper = document.querySelector( '.anacrm-activity-form-accordion' );
	if ( ! wrapper ) {
		return;
	}

	const successDiv = wrapper.querySelector( '.pods-form-front-success' );
	if ( successDiv ) {
		const btn = document.createElement( 'button' );
		btn.type = 'button';
		btn.className = 'px-3 py-2 text-2xl hover:text-yellow cursor-pointer';
		btn.innerHTML = '&times;';
		btn.addEventListener( 'click', () => successDiv.remove() );
		successDiv.appendChild( btn );
	}

	const form = wrapper.querySelector( 'form' );
	if ( ! form ) {
		return;
	}

	let done = false;

	function tryBuild() {
		if ( done ) {
			return;
		}
		if ( ! form.querySelector( '.pods-field__container' ) ) {
			return;
		}
		done = true;
		observer.disconnect();
		buildAccordion( form );
	}

	let debounceTimer = null;
	const observer = new MutationObserver( () => {
		clearTimeout( debounceTimer );
		debounceTimer = setTimeout( tryBuild, 300 );
	} );

	observer.observe( form, { childList: true, subtree: true } );

	tryBuild();
} );
